import { render, staticRenderFns } from "./AuthenticationFptId.vue?vue&type=template&id=c5ecb8d0&scoped=true"
import script from "./AuthenticationFptId.vue?vue&type=script&lang=js"
export * from "./AuthenticationFptId.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5ecb8d0",
  null
  
)

export default component.exports